// extracted by mini-css-extract-plugin
module.exports = {"container":"PackageLocationTable_container__Dx4-S","tableContainer":"PackageLocationTable_tableContainer___wsHC","colorOption":"PackageLocationTable_colorOption__g-tD0"};